import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import clienteModel from "../../models/cliente";
import agendaModel from "../../models/agenda";
import motivoFinalizacaoModel from "../../models/motivoFinalizacao";
import pedidoModel from "../../models/pedido";
import queryString from "query-string";
import moment from "moment";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
PouchDB.plugin(PouchdbFind);

export default class EnderecoEditar extends Component {
  constructor(props) {
    super(props);
    this.loadAgenda = this.loadAgenda.bind(this);
    this.notificar = this.notificar.bind(this);
    this.abrirPaginaEditarAgenda = this.abrirPaginaEditarAgenda.bind(this);
    this.toggle = this.toggle.bind(this);
    this.localizacao = this.localizacao.bind(this);
    this.loadMotivosFinalizacao = this.loadMotivosFinalizacao.bind(this);
    this.finalizarAgenda = this.finalizarAgenda.bind(this);
    this.getLocation = this.getLocation.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.loadAgendaFilha = this.loadAgendaFilha.bind(this);
    this.abrirDetalheAgendaFilha = this.abrirDetalheAgendaFilha.bind(this);
    this.loadPedidoAgenda = this.loadPedidoAgenda.bind(this);
    this.abrirDetalhePedido = this.abrirDetalhePedido.bind(this);
    this.bloqueio = this.bloqueio.bind(this);

    this.state = {
      agenda: null,
      urlMaps: "",
      clienteBanco: null,
      dataAgenda: "",
      exibirAlertaAtraso: false,
      localizacao: false,
      modal: false,
      motivosFinalizacao: [],
      modal2: false,
      motivoSelecionado: null,
      idAgendaFilha: null,
      pedidoAgenda: null,
      db: null,
    };
  }

  async componentDidMount() {
    this.loadAgenda();
  }

  async loadAgenda() {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });
    let idAgenda = queryString.parse(this.props.location.search).id;

    if (idAgenda === undefined) {
      this.props.history.push("/home");
      return false;
    }

    let agenda = await agendaModel.findById(db, idAgenda);

    let data1 = moment(agenda.data);
    let duration = moment.duration(data1.diff(moment().format("YYYY-MM-DD")));
    let diferenca = parseInt(duration.asDays());

    let dataAgenda = "";

    if (diferenca === 0) {
      let dataAgendaComparer = data1;
      dataAgendaComparer = moment(dataAgendaComparer).startOf("day");

      let dataAtual = moment().startOf("day");

      if (dataAgendaComparer.isBefore(dataAtual)) {
        dataAgenda = "Ontem";
        if (agenda.status === "P") {
          this.setState({ exibirAlertaAtraso: true });
        }
      } else {
        dataAgenda = "Hoje";
      }
    } else if (diferenca === 1) {
      dataAgenda = "Amanhã";
    } else {
      dataAgenda = data1.format("DD/MM/YYYY");
    }

    let clienteBanco = await clienteModel.findById(db, agenda.cliente._id);

    if (clienteBanco === null) {
      this.notificar(
        "error",
        "Este cliente não esta mais na carteira do vendedor."
      );

      setTimeout(() => {
        this.props.history.push("/home");
      }, 2000);
      return false;
    }

    agenda.contato.celSemFormat = agenda.contato.cel.replace(/\D/g, "");
    agenda.contato.foneSemFormat = agenda.contato.fone.replace(/\D/g, "");

    clienteBanco.endereco = clienteBanco.enderecos.find(
      (item) => item.principal
    );

    let endereco = clienteBanco.endereco.endereco;
    endereco = endereco.replace(" ", "+");
    endereco = endereco.replace("R:", "Rua");
    endereco = endereco.replace(/\//g, "");
    let numero = clienteBanco.endereco.numero;
    numero = numero.replace("S/N", "");
    numero = numero.replace("0", "");
    numero = numero.replace(/\//g, "");
    let bairro = clienteBanco.endereco.bairro;
    bairro = bairro.replace(" ", "+");
    bairro = bairro.replace(/\//g, "");
    let cidade = clienteBanco.endereco.cidade;
    cidade = cidade.replace(" ", "+");
    cidade = cidade.replace(/\//g, "");
    let estado = clienteBanco.endereco.estado;
    estado = estado.replace(/\//g, "");
    let urlMaps = `https://www.google.com/maps/place/${endereco}+${numero}+${bairro}+${cidade}+${estado}`;

    this.setState(
      {
        agenda,
        urlMaps,
        clienteBanco,
        dataAgenda,
        db: db,
      },
      () => {
        if (agenda.status === "F") {
          if (agenda.finalizadoSucesso) {
            if (agenda.idPedido !== undefined && agenda.idPedido !== null) {
              this.loadPedidoAgenda();
            }
          } else {
            if (agenda.motivoFinalizacao.solicitaReagendamento) {
              //this.loadAgendaFilha();
            }
          }
        }
      }
    );
    await this.getLocation();
  }

  async getLocation() {
    if (navigator.geolocation) {
      await navigator.geolocation.getCurrentPosition(
        // Success function
        this.localizacao,
        // Error function
        this.bloqueio,
        // Options. See MDN for details.
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  async localizacao() {
    let loc = false;
    await navigator.permissions
      .query({ name: "geolocation" })
      .then(function (result) {
        loc = result.state;
      });
    this.setState({ localizacao: true });
  }

  async bloqueio() {
    this.setState({ localizacao: false });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  abrirPaginaEditarAgenda() {
    let idAgenda = queryString.parse(this.props.location.search).id;

    this.props.history.push(`/agenda-editar?id=${idAgenda}`);
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  toggle2() {
    this.setState({ modal2: !this.state.modal2 });
  }

  async loadMotivosFinalizacao() {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });
    let motivos = await motivoFinalizacaoModel.findAll(db);

    if (motivos.length === 0) {
      alert("O Banco de dados não possuí motivos de finalização cadastrado");
    } else {
      motivos = motivos.map((item) => {
        item.value = item.desc;
        item.label = item.desc;
        return item;
      });
    }

    this.setState({ motivosFinalizacao: motivos });
  }

  async finalizarAgenda(finalizadoSucesso, motivoFinalizacao) {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });

    let agenda = this.state.agenda;
    let agenda2 = null;

    if (motivoFinalizacao !== null) {
      if (motivoFinalizacao.solicitaReagendamento) {
        agenda2 = Object.assign({}, agenda);
        delete agenda2._id;
        delete agenda2._rev;
        agenda2.dataCriacao = new Date();
        agenda2.data = new Date();
        agenda2.idAgendaPai = agenda._id;
      }
    }

    agenda.status = "F";
    agenda.dataFinalizacao = new Date();
    agenda.finalizadoSucesso = finalizadoSucesso;
    agenda.motivoFinalizacao = motivoFinalizacao;

    await agendaModel.salvarAgenda(db, agenda);

    if (agenda2 !== null) {
      await db.post(agenda2);

      let agendaNova = await agendaModel.findByAgendaPai(db, agenda._id);
      localStorage.setItem("idAgenda", agendaNova._id);

      this.props.history.push(`/agenda-editar?id=${agendaNova._id}`);
    } else {
      window.location.reload();
    }

    ///
  }

  async loadAgendaFilha() {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });
    //let idAgenda = localStorage.getItem("idAgenda");
    let idAgenda = queryString.parse(this.props.location.search).id;
    let agenda = await agendaModel.findByAgendaPai(db, idAgenda);
    this.setState({ idAgendaFilha: agenda._id });
  }

  async abrirDetalheAgendaFilha() {
    localStorage.setItem("idAgenda", this.state.idAgendaFilha);
    window.location.reload();
  }

  async loadPedidoAgenda() {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });

    const pedido = await pedidoModel.findById(db, this.state.agenda.idPedido, [
      "_id",
      "type",
      "codigo",
    ]);

    this.setState({ pedidoAgenda: pedido });
  }

  async abrirDetalhePedido() {
    const pedido = this.state.pedidoAgenda;

    if (pedido.type === "orcamento") {
      localStorage.setItem("idPedido", pedido._id);
      this.props.history.push("/pedidos/editar");
    } else {
      this.props.history.push(`/pedidos/detalhe?id=${pedido._id}`);
    }
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Detalhe da Agenda" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"novoPedido"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title={`Cadastrar Pedido`}
                  description="Adicionar um novo pedido"
                /> */}

                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    {this.state.agenda !== null && (
                      <div className="card">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-7">
                              <div
                                className="float-left width-100"
                                style={{ paddingBottom: "5px" }}
                              >
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#80217e",
                                    fontSize: "17px",
                                  }}
                                >
                                  <span style={{ textTransform: "uppercase" }}>
                                    #{this.state.agenda.acao}
                                  </span>
                                </span>
                              </div>

                              <div
                                className="float-left width-100"
                                style={{ paddingBottom: "5px" }}
                              >
                                <span>
                                  <img
                                    className="img-responsive"
                                    src={"../images/calendar.svg"}
                                    alt="calendar"
                                    style={{
                                      width: "15px",
                                      marginTop: "-2px",
                                    }}
                                  />{" "}
                                  {this.state.dataAgenda}
                                  {this.state.agenda.horario !== null
                                    ? `, às ${this.state.agenda.horario}`
                                    : ""}{" "}
                                  {this.state.agenda.status === "P" &&
                                    this.state.agenda.tipo === "manual" && (
                                      <i
                                        className="fa fa-pencil"
                                        style={{
                                          color: "#7ED321",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          this.abrirPaginaEditarAgenda()
                                        }
                                      ></i>
                                    )}
                                </span>

                                <div
                                  style={{
                                    color: "#7ED321",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {this.state.agenda.status === "P"
                                    ? "PENDENTE"
                                    : "FINALIZADA"}
                                </div>
                              </div>

                              <div className="float-left width-100 font-size-16">
                                <span> {this.state.agenda.cliente.desc}</span>
                              </div>

                              <div
                                className="float-left width-100 font-size-14"
                                style={{ minHeight: "18px" }}
                              >
                                <span>
                                  {this.state.agenda.cliente.fantasia}
                                </span>
                              </div>

                              <div
                                className="float-left width-100 font-size-14"
                                style={{ paddingTop: "20px" }}
                              >
                                <span style={{ fontWeight: "bold" }}>
                                  Endereço principal
                                </span>
                              </div>

                              <div className="row">
                                <div
                                  className="col-1 d-flex"
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <a
                                    href={`${this.state.urlMaps}`}
                                    target="_blank"
                                  >
                                    <i
                                      className="fa fa-map-marker"
                                      syle="fontSize:22px"
                                      style={{
                                        fontSize: "30px",
                                        color: "#666",
                                      }}
                                    ></i>
                                  </a>
                                </div>

                                <div className="col-11 font-size-14">
                                  <div>
                                    {this.state.clienteBanco.endereco.endereco},{" "}
                                    {this.state.clienteBanco.endereco.numero}
                                  </div>
                                  <div>
                                    {
                                      this.state.clienteBanco.endereco
                                        .complemento
                                    }
                                  </div>
                                  <div>
                                    {this.state.clienteBanco.endereco.bairro} -{" "}
                                    {this.state.clienteBanco.endereco.cidade} -{" "}
                                    {this.state.clienteBanco.endereco.estado}
                                  </div>
                                  <div>
                                    {" "}
                                    CEP: {this.state.clienteBanco.endereco.cep}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-5">
                              <div
                                className="float-left width-100 font-size-14"
                                style={{ marginTop: "85px" }}
                              >
                                <span>
                                  CNPJ: {this.state.clienteBanco.cnpjCpf}{" "}
                                </span>
                              </div>
                              <div className="float-left width-100 font-size-14">
                                <span>I.E: 115155 </span>
                              </div>

                              <div
                                className="float-left width-100 font-size-14"
                                style={{ paddingTop: "20px" }}
                              >
                                <span style={{ fontWeight: "bold" }}>
                                  Contato principal
                                </span>
                              </div>

                              <div className="row">
                                <div
                                  className="col-1 d-flex"
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <a
                                    href={`https://wa.me/+55${this.state.agenda.contato.celSemFormat}`}
                                    target="_blank"
                                    className="link-app"
                                  >
                                    <i
                                      className="fa fa-whatsapp"
                                      syle="fontSize:22px"
                                      style={{
                                        fontSize: "30px",
                                        color: "rgb(0, 168, 89)",
                                      }}
                                    ></i>
                                  </a>
                                </div>

                                <div className="col-11 font-size-14">
                                  <div>{this.state.agenda.contato.desc}</div>
                                  <div>{this.state.agenda.contato.email}</div>
                                  <div>{this.state.agenda.contato.fone}</div>
                                  <div>{this.state.agenda.contato.cel}</div>
                                </div>
                              </div>
                            </div>

                            <div className="col-12">
                              <div
                                className="float-left width-100"
                                style={{
                                  padding: "1px",
                                  fontWeight: "bold",
                                  paddingBottom: "40px",
                                  paddingTop: "10px",
                                }}
                              >
                                Observação:{" "}
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: this.state.agenda.obs,
                                  }}
                                ></div>
                              </div>
                            </div>

                            {this.state.agenda !== null &&
                              this.state.agenda.status === "P" && (
                                <div className="d-flex float-left w-100 pd-pedido">
                                  <div style={{ margin: "5px" }}>
                                    <button
                                      className="btn btn-success"
                                      onClick={() => {
                                        if (
                                          this.state.motivosFinalizacao
                                            .length === 0
                                        ) {
                                          this.loadMotivosFinalizacao();
                                        }

                                        this.toggle();
                                      }}
                                    >
                                      Finalizar
                                    </button>
                                  </div>
                                  <div style={{ margin: "5px" }}>
                                    <button
                                      className="btn btn-secondary"
                                      onClick={() => {
                                        this.props.history.push(
                                          `/pedidos-novo?agenda=${this.state.agenda._id}&cliente=${this.state.agenda.cliente._id}`
                                        );
                                      }}
                                    >
                                      Novo pedido
                                    </button>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader>Finalizar Agenda</ModalHeader>
          <ModalBody>Agenda finalizada com sucesso?</ModalBody>
          <ModalFooter>
            <button
              className="btn btn-danger"
              onClick={(e) => this.finalizarAgenda(true, null)}
            >
              Sim
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => {
                this.toggle();
                this.toggle2();
              }}
            >
              Não
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modal2} toggle={this.toggle2}>
          <ModalHeader>Finalizar Agenda</ModalHeader>
          <ModalBody>
            <div className="form-group">
              <label>Motivo</label>
              <Select
                options={this.state.motivosFinalizacao}
                value={this.state.motivoSelecionado}
                onChange={(motivoSelecionado) =>
                  this.setState({ motivoSelecionado })
                }
                placeholder="Selecione"
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-danger"
              onClick={(e) => {
                this.finalizarAgenda(false, this.state.motivoSelecionado);
              }}
            >
              Finalizar
            </button>
            <button className="btn btn-secondary" onClick={this.toggle2}>
              Cancelar
            </button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}
